import { TriangleAlert } from "@tamagui/lucide-icons";
import type { Timestamp } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { XStack } from "tamagui";
import { getDayJs } from "../../../core/dayJs";
import { Body } from "../../../ui/Body";

export const BusinessDateDue: React.FC<{ dateDue: Timestamp }> = ({
  dateDue,
}) => {
  const isLate = Date.now() > dateDue.toMillis();

  const { t } = useTranslation();

  if (isLate) {
    return (
      <XStack alignItems="center" gap="$small">
        <TriangleAlert color={"$danger"} size={16} />
        <Body color="$danger">
          {t("business:date_due")} {getDayJs(dateDue)}
        </Body>
      </XStack>
    );
  }

  return (
    <Body>
      {t("business:date_due")} {getDayJs(dateDue)}
    </Body>
  );
};
